import React from 'react';
import { useI18n } from '../i18n';

const Sidebar = ({ selectedParcel, onContactClick }) => {
  const { t } = useI18n();

  if (!selectedParcel) {
    return (
      <div className="sidebar">
        <h2>{t('sidebar_title')}</h2>
        <div className="welcome-message">
          <h3>{t('sidebar_welcome_title')}</h3>
          <p className="welcome-desc">{t('sidebar_welcome_desc')}</p>
          <ul className="welcome-steps">
            <li>{t('sidebar_welcome_click')}</li>
            <li>{t('sidebar_welcome_layers')}</li>
            <li>{t('sidebar_welcome_zoom')}</li>
            <li>{t('sidebar_welcome_markers')}</li>
          </ul>
          <p className="welcome-cta">{t('sidebar_welcome_select')}</p>
        </div>
      </div>
    );
  }

  const isSold = selectedParcel.status === 'sold';

  return (
    <div className="sidebar">
      <div className="parcel-info">
        <h3>{selectedParcel.name}</h3>
        
        <div className={`status-badge ${isSold ? 'status-sold' : selectedParcel.status === 'available' ? 'status-available' : 'status-unavailable'}`}>
          {isSold ? t('properties_sold') : selectedParcel.status === 'available' ? t('properties_available') : t('properties_not_available')}
        </div>

        {!isSold && (
          <div className="price">{selectedParcel.price.toLocaleString()}</div>
        )}
        
        <div className="parcel-details">
          <p><strong>{t('properties_size_label')}</strong> {selectedParcel.size}</p>
          <p><strong>{t('properties_location_label')}</strong> {selectedParcel.location}</p>
        </div>
        
        {selectedParcel.description && (
          <div className="parcel-description">
            <h4>{t('sidebar_description_title')}</h4>
            <p>{selectedParcel.description}</p>
          </div>
        )}
        
        <div className="features">
          <h4>{t('sidebar_features_title')}</h4>
          <ul>
            {selectedParcel.features.filter(feature => !feature.startsWith('Official name:')).map((feature, index) => (
              <li key={index}>{feature}</li>
            ))}
          </ul>
        </div>
        
        {!isSold && (
          <button 
            className="contact-btn" 
            onClick={onContactClick}
          >
            {t('sidebar_contact_btn')}
          </button>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
